import { ILocation } from '../../../libraries/location';
import { AppAction } from '../actions';
import { ActionTypes } from './actionTypes';

export interface LocationState {
  locations: ILocation[];
}

const initialState: LocationState = { locations: [] };

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: AppAction<any>): LocationState => {
  switch (action.type) {
    case ActionTypes.SAVE_LOCATIONS: {
      return {
        ...state,
        locations: action.payload
      };
    }
    default:
      return state;
  }
};
